import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-bed-white',
  templateUrl: './icon-bed-white.component.html',
  styles: []
})
export class IconBedWhiteComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
